import axios from "axios";
import LocalStorageService from "./services/LocalStorage";
const API_URL = process.env.VUE_APP_API_URL || "http://localhost:3001/api/v1";
const localStorageService = LocalStorageService.getService();

// `baseURL` is prepended to URLs passed to axios
axios.defaults.baseURL = API_URL;

// POST with JSON content type
axios.defaults.headers.post["Content-Type"] = "application/json";

export default {
  getStationInfo() {
    return axios.get("/station_info");
  },

  getScannableAssets() {
    return axios.get("/assets");
  },

  getAllAssetStates() {
    return axios.get("/scan_states?all=true");
  },

  getAllLocations() {
    return axios.get("/locations");
  },

  getUserList() {
    return axios.get("/users");
  },

  createScan(newScan) {
    return axios.post("/scans", newScan);
  },

  findScan(scanCode) {
    return axios.get(`/scans/search/${scanCode}`);
  },

  createStation(newStation) {
    return axios.post("/stations", newStation);
  },

  deleteStation(stationId) {
    return axios.delete(`/stations/${stationId}`);
  },

  updateStation(stationId, stationInfo) {
    return axios.put(`/stations/${stationId}`, stationInfo);
  },

  getRecentScans() {
    return axios.get("/scans");
  },

  getStationList() {
    return axios.get("/stations");
  },

  getScanStates() {
    return axios.get("/scan_states");
  },

  createSession(email, password) {
    return axios.post("/auth/sign_in", { email, password });
  },
  deleteSession() {
    return axios.delete("/auth/sign_out", {});
  },

  deleteUser(id) {
    return axios.delete(`/users/${id}`);
  },
  createUser(newUser) {
    return axios.post("/auth", newUser);
  },
  deleteAsset(id) {
    return axios.delete(`/assets/${id}`);
  },
  deleteAssetState(id) {
    return axios.delete(`/scan_states/${id}`);
  },
  deleteLocation(id) {
    return axios.delete(`/locations/${id}`);
  },
  createAsset(newAsset) {
    return axios.post("/assets", newAsset);
  },
  createAssetState(newAssetState) {
    return axios.post("/scan_states", newAssetState);
  },
  createLocation(newLocation) {
    return axios.post("/locations", newLocation);
  },
  updateAsset(id, newStatus) {
    return axios.put(`/assets/${id}`, newStatus);
  },
};

// Intercept all 401 Unauthorized responses before
// they are handled by `then` or `catch`
import router from "./router";

axios.interceptors.response.use(
  function(response) {
    return response;
  },
  function(error) {
    const originalRequest = error.config;

    //Network Error
    !error.response
      ? alert(`Unable to access backend API: ${error.message}`)
      : null;

    if (
      error.response.status === 401 &&
      originalRequest.url === `${API_URL}/auth/validate_token`
    ) {
      // Clear user and redirect to sign in
      localStorageService.clearUser();
      router.push("/sign-in");
      return Promise.reject(error);
    }

    if (error.response.status == 401 && !originalRequest._retry) {
      originalRequest._retry = true;
      return axios.get("/auth/validate_token", {}).then((res) => {
        if (res.status === 201) {
          // 1) store access keys in LocalStorage
          localStorageService.setAccessKeys(res.headers);

          // 2) Load updated access keys for a retry. Keys = access-token, expiry, uid, client
          const accessKeys = localStorageService.getAccessKeys();

          if (accessKeys) {
            for (let key in accessKeys) {
              if (accessKeys.hasOwnProperty(key)) {
                axios.defaults.headers[`${key}`] = `${accessKeys[key]}`;
              }
            }
          }

          // 3) return originalRequest object with Axios.
          return axios(originalRequest);
        }
      });
    }
    console.error(error);
    return Promise.reject(error);
  }
);

// Intercept Requests
axios.interceptors.request.use(
  (config) => {
    const accessKeys = localStorageService.getAccessKeys();

    if (accessKeys) {
      for (let key in accessKeys) {
        if (accessKeys.hasOwnProperty(key)) {
          config.headers[`${key}`] = `${accessKeys[key]}`;
        }
      }
    }
    return config;
  },
  (error) => {
    Promise.reject(error);
  }
);
